import { DesignsDraftApi, useAPIAction } from "melco-shared-logic";
import { isPrintDesignFileName } from "../../../helper/designHelper";
import { NOTIFICATIONS_CACHE_KEY } from "../../notifications/useNotifications";
import { useQueryClient } from "react-query";

export const useDesignUpload = () => {
  const queryClient = useQueryClient();

  const [uploadDesign] = useAPIAction(
    DesignsDraftApi,
    async (api, file: Blob) => {
      const isPrintFile = isPrintDesignFileName(file.name);

      const data = isPrintFile
        ? await api.userDesignsPrintQueueUploadDraft({
          file,
        })
        : await api.userDesignsUploadDraft({
          file,
        });

      return {
        successMessages: [
          {
            message: isPrintFile ? "print" : "default",
          },
        ],
        data,
      };
    },
    {
      translationPrefix: "designs.actions.upload",
      onSuccess: () => {
        queryClient.invalidateQueries(NOTIFICATIONS_CACHE_KEY);
      },
    }
  );

  return {
    uploadDesign,
  } as const;
};
